import { createUseStyles } from '@pe-libs/react-components/build/theme';

const useStyles = createUseStyles('default-landing-socials', () => ({
  container: {
    display: 'flex',
    justifyContent: 'center',

    '& a': {
      fontSize: '2rem',
      marginLeft: '0.75rem',
      '&:first-child': {
        marginLeft: 0,
      },
    },
  },
}));

export default useStyles;
